<!--病例实战 -->
<template>
    <div class="case-list-section">
        <div class="case-list-section-box" @click="go(dataItem)">
            <div class="case-list-section-left">
                <van-image class="case-list-section-left-img" fit="cover" :src="dataItem.content.cover_img" />
            </div>
            <div class="case-list-section-right">
                <div class="case-list-section-right-title">{{ dataItem.content.title }}</div>
                <div class="case-list-section-right-detail" v-if="dataItem.type == 2">
                    共{{ dataItem.total_count }}篇
                    <span
                        class="case-list-section-right-detail-join"
                        v-if="dataItem.is_subscribe === 1"
                        @click.stop="attention(dataItem.content, dataItem)"
                    >
                        <img src="static/v4/icon_follow.svg" style="margin-right: 2px" />关注</span
                    >
                    <span v-else class="case-list-section-right-detail-join1" @click.stop="attention(dataItem.content, dataItem)">已关注</span>
                </div>
                <div class="case-list-section-right-detail" v-else>
                    <span>{{ dataItem.content.created_at }}</span>
                    <span>{{ dataItem.content.view_count }}人阅读</span>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
export default {
    name: 'case',
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    methods: {
        // 关注/未关注
        attention(content, item) {
            // is_subscribe 0 已关注  1 未关注
            if (content.is_subscribe == 0) {
                // 取消关注
                this.$dialog
                    .confirm({
                        title: '提醒',
                        message: '确定取消关注吗？',
                        confirmButtonText: '确定',
                        className: 'dly-dialog'
                    })
                    .then(() => {
                        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                            if (res.code == 0) {
                                this.$toast.success('取消关注成功')
                                // this.changeCategory()
                            }
                        })
                    })
                    .catch(() => {
                        console.log(1)
                    })
            } else {
                // 关注
                Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                    if (res.code == 0) {
                        this.$toast.success('关注成功')
                        // this.$parent.$parent.changeCategory()
                    }
                })
            }
        },
        go(item) {
            const pathUrl = item.type === 1 ? 'article-detail' : 'case-column'
            this.$router.push({ name: pathUrl, params: { id: item.origin_id } })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/components/case-list-new.scss';
.case-list-section-box {
    width: 355px;
    background: #fff;
    margin: 0 auto;
    border-radius: 8px;
    margin-top: 10px;
}
.case-list-section-left {
    padding-left: 12px;
}
.case-list-section-right {
    padding-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/newItemconent/modules/case.vue